<template>
  <div>
    <carousel />
    <student />
    <teacher />

    <div class="my-5 py-5">
      <h1 class="text-center"><b>Veja como a Akademica pode ajudar a<br>turbinar os seus estudos!</b></h1>
    </div>

    <!-- <video-institutional /> -->
    <courses />

    <div class="my-5 py-5">
      <h1 class="text-center"><b>Uma experiência completa<br>para aluno e professor</b></h1>
    </div>

    <testimonials />
  </div>
</template>

<script>
import Carousel from './../../components/front/Carousel'
import Courses from './../../components/front/Courses'
import Student from './../../components/front/Student'
import Teacher from './../../components/front/Teacher'
import Testimonials from './../../components/front/Testimonials'
import Video from './../../components/front/Video'

export default {
  name: 'front',
  components: {
    carousel: Carousel,
    courses: Courses,
    student: Student,
    teacher: Teacher,
    testimonials: Testimonials,
    "video-institutional": Video,
  }
}
</script>
